import AdvancedFinderComponent from "./components/AdvancedFinderComponent.component.vue";

export function createApp() {
    Vue.component('advanced-finder', AdvancedFinderComponent)
}
